export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA"
export const UPDATE_LOADING_DASHBOARD = "UPDATE_LOADING_DASHBOARD"
export const UPDATE_PAGINATION_DASHBOARD_SURVEY_LIST = "UPDATE_PAGINATION_DASHBOARD_SURVEY_LIST"